.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.emptyState {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-text-dimmed);
}

.toolbar {
  display: flex;
  gap: 16px;
  margin-bottom: 12px;
  align-items: center;
}

.toolbar label {
  display: flex;
  flex-direction: column;
  font-size: 11px;
  color: var(--color-text-dimmed);
  gap: 4px;
}

.toolbar select,
.toolbar input {
  padding: 4px;
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 4px;
}

.tableContainer {
  flex: 1;
  overflow-y: auto;
  border: 1px solid var(--color-border);
  border-radius: 4px;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th, .table td {
  padding: 6px 12px;
  text-align: left;
  border-bottom: 1px solid var(--color-border);
  font-size: 12px;
}

.table th {
  background: var(--color-bg-header);
  position: sticky;
  top: 0;
  color: var(--color-text-dimmed);
  font-weight: 600;
}

.valueCell {
  font-family: monospace;
  font-weight: bold;
}
